<template>
  <snackbar
    ref="snackbar"
    baseSize="100px"
    :holdTime="5000"
    :multiple="true"
    :position="'bottom-center'"
    :colors="colors"
  />
</template>

<script>
import Vue from "vue";
import Snackbar from "@/components/Shared/snackbar.vue";

import { StringHelper } from "@/helpers/utilities/StringHelper";
import { useGlobalsStore } from "@/stores/globals";

export default {
  name: "GlobalSnackbar",

  data() {
    return {
      requestMap: {} // requestId: snackbarId
    };
  },

  setup() {
    return {
      globalsStore: useGlobalsStore()
    };
  },

  watch: {
    "$skboMessage.message"(message) {
      if (message) {
        switch (message.type) {
          case "error":
            this.requestMap[message.requestId] = this.$refs.snackbar.addError(
              this.parseMessage(message.text),
              message.keepOpen
            );
            break;

          case "warn":
            this.requestMap[message.requestId] = this.$refs.snackbar.addWarning(
              this.parseMessage(message.text),
              message.keepOpen
            );
            break;

          case "update":
            this.$refs.snackbar.update(this.requestMap[message.requestId], this.parseMessage(message.text));
            break;

          case "close":
            this.$refs.snackbar.remove(this.requestMap[message.requestId]);
            break;

          default:
            this.requestMap[message.requestId] = this.$refs.snackbar.addInfo(
              this.parseMessage(message.text),
              message.keepOpen
            );
            break;
        }
      }
    },

    "globalsStore.infoMessage"(message) {
      if (message) {
        this.$refs.snackbar.addInfo(this.parseMessage(message));
        this.globalsStore.setInfoMessage(null);
      }
    },

    "globalsStore.errorMessage"(message) {
      if (message) {
        this.$refs.snackbar.addError(this.parseMessage(message));
        this.globalsStore.setErrorMessage(null);
      }
    }
  },

  messageState: Vue.observable({
    message: null,

    openMessage(text, keepOpen = false) {
      const requestId = Math.floor(Math.random() * 100000);

      this.message = null;
      setTimeout(() => {
        this.message = {
          requestId: requestId,
          text: text,
          type: "open",
          keepOpen: keepOpen
        };
      });
      return requestId;
    },

    infoMessage(text, keepOpen = false) {
      const requestId = Math.floor(Math.random() * 1000000);

      this.message = null;
      setTimeout(() => {
        this.message = {
          requestId: requestId,
          text: text,
          type: "info",
          keepOpen: keepOpen
        };
      });
      return requestId;
    },

    warnMessage(text, keepOpen = false) {
      const requestId = Math.floor(Math.random() * 1000000);

      this.message = null;
      setTimeout(() => {
        this.message = {
          requestId: requestId,
          text: text,
          type: "warn",
          keepOpen: keepOpen
        };
      });
      return requestId;
    },

    errorMessage(text, keepOpen = false) {
      const requestId = Math.floor(Math.random() * 1000000);

      this.message = null;
      setTimeout(() => {
        this.message = {
          requestId: requestId,
          text: text && text !== "" ? text : "An error occured", // TODO Translate
          type: "error",
          keepOpen: keepOpen
        };
      });
      return requestId;
    },

    updateMessage(requestId, text) {
      this.message = {
        requestId: requestId,
        text: text,
        type: "update"
      };
    },

    closeMessage(requestId) {
      this.message = {
        requestId: requestId,
        type: "close"
      };
    }
  }),

  computed: {
    colors() {
      return {
        warning: "#F4642D",
        error: "var(--color-danger)",
        info: "var(--color-primary-light)"
      };
    }
  },

  methods: {
    localizeMessage(message) {
      if (message.startsWith("$t(")) {
        return this.$t(StringHelper.cleanForTranslationTag(message));
      }

      return message;
    },

    parseMessage(message) {
      if (Array.isArray(message)) {
        return message
          .map(m => {
            if (m.toString().startsWith("$t(")) {
              return this.$t(StringHelper.cleanForTranslationTag(m));
            } else {
              return m;
            }
          })
          .join(" ");
      }

      return this.localizeMessage(message);
    }
  },

  components: { Snackbar }
};
</script>
